module.exports = __webpack_public_path__ + "img/Bouton_Etape_Precedente.a70ddf32.svg";